import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, Overline, FadeUp } from "./Reveal";
import { GALLERY } from "./data";

const Frame = ({ g, i, className = "" }) => (
  <figure data-testid={`gallery-item-${i}`} className={`group shrink-0 ${className}`}>
    <div className={`relative overflow-hidden bg-[#050505] border border-white/10 ${i % 2 ? "rounded-[24px]" : "rounded-t-full"} w-full h-full`}>
      <img src={g.src} alt={g.label} loading="lazy" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-1000 group-hover:scale-105" />
      <div className="absolute inset-0 ring-1 ring-inset ring-gold/0 group-hover:ring-gold/50 transition-[box-shadow] duration-500" />
    </div>
    <figcaption className="mt-4 flex justify-between font-mono text-[11px] uppercase tracking-[0.2em]">
      <span className="text-ivory">{g.label}</span>
      <span className="text-gold">{g.tag}</span>
    </figcaption>
  </figure>
);

const Heading = () => (
  <div>
    <Overline>Galleria</Overline>
    <h2 className="mt-4 font-display text-4xl sm:text-5xl xl:text-6xl leading-[0.95] text-ivory">
      <MaskLines lines={["Lavori che", <em key="g" className="text-gold-grad">parlano da sé.</em>]} />
    </h2>
  </div>
);

export const Gallery = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const x = useTransform(scrollYProgress, [0, 1], ["0%", "-66%"]);

  return (
    <section id="galleria" data-testid="gallery-section" className="relative bg-obsidian-2">
      <div ref={ref} className="hidden lg:block relative h-[280vh]">
        <div className="sticky top-0 h-screen overflow-hidden flex flex-col justify-start pt-[5vh]">
          <div className="max-w-[1400px] w-full mx-auto px-8 mb-[2vh]"><Heading /></div>
          <motion.div style={{ x }} className="flex gap-10 pl-[max(2rem,calc((100vw-1400px)/2+2rem))] items-start">
            {GALLERY.map((g, i) => (
              <div key={g.src} className={`shrink-0 h-[48vh] max-h-[460px] aspect-[4/5] ${i % 2 ? "mt-[3vh]" : ""}`}>
                <Frame g={g} i={i} className="w-full h-full" />
              </div>
            ))}
          </motion.div>
        </div>
      </div>
      <div className="lg:hidden px-5 sm:px-8 py-24">
        <Heading />
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-8">
          {GALLERY.map((g, i) => (
            <FadeUp key={g.src} delay={(i % 2) * 0.1}>
              <div className="aspect-[4/5] w-full"><Frame g={g} i={i} className="w-full h-full" /></div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
